/**
 * Workflows the Outlook pane never offers to START (Joachim, 2026-10-06).
 *
 * They stay on the SHARED catalog because ora needs them: the bulk launch page
 * reads its check options from epic_bulk_policy_update_v1, ora's Monitor reads
 * epic_bulk_review_v1's title and step names, and oraFix launches from its
 * campaign page. This list only removes their Start cards from the pane. The
 * pane still resolves their titles and steps from the full catalog, so a run
 * of one of them in the queue still renders by name.
 *
 * Applied in LaunchTab.tsx (visibleCatalog filter) and ContextStripHost.tsx
 * (workflowOptions for the "Start another workflow" picker).
 *
 * A hard-coded list by decision (not a catalog flag): adding an id here is a
 * plugin release.
 */
export const PLUGIN_HIDDEN_WORKFLOW_IDS: ReadonlySet<string> = new Set([
  "epic_bulk_policy_update_v1",
  "epic_bulk_review_v1",
  "orafix_run_v1",
  // Joachim, 2026-10-06 (later): the pane's Start list is v2 + the two [Test] tools only.
  "mortgagee_update_v1_2",
  "policy_check_v3a",
  "policy_check_v3b",
]);

export function isLaunchableInPlugin(entry: { id?: string | null }): boolean {
  return !(entry.id && PLUGIN_HIDDEN_WORKFLOW_IDS.has(entry.id));
}
